// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help-requests-column {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
    overflow: hidden;
  }
  
  .help-requests-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 15px 20px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    transition: background 0.3s;
  }
  
  .help-requests-header:hover {
    background: linear-gradient(135deg, #5a67d8 0%, #6b46a0 100%);
  }
  
  .help-requests-icon {
    font-size: 14px;
    transition: transform 0.2s;
  }
  
  .help-requests-title {
    font-size: 18px;
    font-weight: 600;
  }
  
  .help-requests-content {
    padding: 15px;
  }
  
  .help-requests-section {
    margin-bottom: 20px;
  }
  
  .help-requests-subheader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    margin-bottom: 10px;
    border-bottom: 2px solid #e0e0e0;
    font-weight: 600;
    color: #333;
  }
  
  .requests-count {
    background: #667eea;
    color: white;
    padding: 2px 8px;
    border-radius: 20px;
    font-size: 12px;
  }
  
  .help-requests-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  
  .help-request-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 15px;
    background: #f8f9fa;
    border-radius: 10px;
    border-left: 4px solid #ff9800;
    transition: transform 0.2s, box-shadow 0.2s;
  }
  
  .help-request-card:hover {
    transform: translateX(2px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .help-request-info {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  
  .help-request-user {
    font-weight: 600;
    color: #333;
    font-size: 14px;
  }
  
  .help-request-task {
    color: #555;
    font-size: 13px;
    word-break: break-word;
  }
  
  .help-request-project {
    color: #888;
    font-size: 12px;
  }
  
  .help-request-status {
    display: inline-block;
  }
  
  .status-badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 600;
  }
  
  .status-in-queue {
    background: #fff3e0;
    color: #ff9800;
  }
  
  .status-in-progress {
    background: #e3f2fd;
    color: #2196f3;
  }
  
  .help-request-time {
    font-family: monospace;
    font-size: 13px;
    color: #666;
  }
  
  .help-request-take-btn {
    background: #4caf50;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    transition: background 0.2s;
    white-space: nowrap;
  }
  
  .help-request-take-btn:hover {
    background: #45a049;
  }
  
  .answered-requests-section {
    margin-top: 10px;
  }
  
  .answered-requests-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 0;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    font-weight: 600;
    color: #555;
    border-top: 1px solid #e0e0e0;
    margin-top: 10px;
  }
  
  .answered-requests-header:hover {
    color: #333;
  }
  
  .answered-requests-icon {
    font-size: 12px;
  }
  
  .answered-requests-title {
    font-size: 14px;
  }
  
  .answered-requests-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 10px;
  }
  
  .answered-request-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 12px;
    background: #e8f5e9;
    border-radius: 8px;
    border-left: 4px solid #4caf50;
  }
  
  .answered-request-info {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  
  .answered-request-user {
    font-weight: 600;
    color: #333;
    font-size: 13px;
  }
  
  .answered-request-task {
    color: #555;
    font-size: 12px;
  }
  
  .answered-request-mentor {
    color: #666;
    font-size: 11px;
  }
  
  .answered-request-answer {
    font-size: 11px;
    color: #4caf50;
    font-weight: 500;
  }
  
  .answered-request-timer {
    font-size: 11px;
    font-family: monospace;
    color: #ff9800;
  }
  
  .answered-request-timer.expired {
    color: #f44336;
    font-weight: bold;
  }
  
  .answered-request-status {
    font-size: 11px;
    color: #4caf50;
    font-weight: 500;
  }
  
  .answered-request-buttons {
    display: flex;
    gap: 8px;
    align-items: center;
  }
  
  .answered-request-done-btn {
    background: #2196f3;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 11px;
    font-weight: 500;
    transition: background 0.2s;
  }
  
  .answered-request-done-btn:hover {
    background: #1976d2;
  }
  
  .answered-request-link {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    background: #e0e0e0;
    border-radius: 6px;
    text-decoration: none;
    color: #666;
    font-weight: bold;
    transition: background 0.2s, color 0.2s;
  }
  
  .answered-request-link:hover {
    background: #ccc;
    color: #333;
  }
  
  .no-requests-message {
    text-align: center;
    padding: 30px;
    color: #999;
    font-size: 14px;
  }
  
  /* Modal Styles */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  
  .modal-content {
    background: white;
    border-radius: 12px;
    width: 90%;
    max-width: 500px;
    max-height: 80vh;
    overflow: auto;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  }
  
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    border-bottom: 1px solid #e0e0e0;
  }
  
  .modal-header h3 {
    margin: 0;
    color: #333;
  }
  
  .modal-close {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #999;
  }
  
  .modal-close:hover {
    color: #333;
  }
  
  .modal-body {
    padding: 20px;
  }
  
  .modal-task-info {
    background: #f5f5f5;
    padding: 12px;
    border-radius: 8px;
    margin-bottom: 20px;
  }
  
  .modal-task-info div {
    margin-bottom: 5px;
    font-size: 14px;
  }
  
  .modal-options {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  
  .modal-option {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    font-size: 14px;
  }
  
  .minutes-input {
    width: 70px;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-left: 5px;
  }
  
  .modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 15px 20px;
    border-top: 1px solid #e0e0e0;
  }
  
  .modal-cancel {
    background: #f5f5f5;
    border: 1px solid #ccc;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
  }
  
  .modal-submit {
    background: #4caf50;
    color: white;
    border: none;
    padding: 8px 20px;
    border-radius: 6px;
    cursor: pointer;
  }
  
  .modal-submit:hover {
    background: #45a049;
  }
  
  /* Dark theme support */
  .dark-theme .help-requests-column {
    background: #1e1e2e;
  }
  
  .dark-theme .help-requests-subheader {
    color: #e0e0e0;
    border-bottom-color: #444;
  }
  
  .dark-theme .help-request-card {
    background: #2a2a3a;
  }
  
  .dark-theme .help-request-user,
  .dark-theme .help-request-task,
  .dark-theme .help-request-project {
    color: #e0e0e0;
  }
  
  .dark-theme .answered-request-card {
    background: #1e3a2e;
  }
  
  .dark-theme .answered-request-user,
  .dark-theme .answered-request-task,
  .dark-theme .answered-request-mentor {
    color: #e0e0e0;
  }
  
  .dark-theme .modal-content {
    background: #2a2a3a;
    color: #e0e0e0;
  }
  
  .dark-theme .modal-task-info {
    background: #1e1e2e;
  }
  
  .dark-theme .modal-header h3 {
    color: #e0e0e0;
  }
  /* Додайте до існуючого CSS */

.mentor-confirmed {
    color: #4caf50;
  }
  
  .mentor-pending {
    color: #ff9800;
  }
  
  .mentor-waiting {
    font-size: 10px;
    color: #ff9800;
    font-style: italic;
  }
  
  .status-section {
    margin-top: 6px;
    padding: 4px 8px;
    border-radius: 6px;
    transition: all 0.3s ease;
  }
  
  .status-active-section {
    background: rgba(76, 175, 80, 0.1);
    border-left: 3px solid #4caf50;
  }
  
  .status-inactive-section {
    background: rgba(158, 158, 158, 0.05);
    border-left: 3px solid #9e9e9e;
    opacity: 0.7;
  }
  
  .status-header {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .status-icon {
    font-size: 12px;
  }
  
  .status-name {
    font-size: 11px;
    font-weight: 500;
  }
  
  .status-active-section .status-name {
    color: #4caf50;
  }
  
  .status-inactive-section .status-name {
    color: #9e9e9e;
  }
  
  .status-timer {
    font-family: monospace;
    font-size: 11px;
    color: #666;
    background: rgba(0, 0, 0, 0.05);
    padding: 2px 6px;
    border-radius: 12px;
    margin-left: auto;
  }
  
  .answered-request-current-status {
    font-size: 10px;
    color: #888;
    margin-top: 6px;
    font-family: monospace;
    padding-top: 4px;
    border-top: 1px dashed #e0e0e0;
  }
  
  .answered-request-to-work-btn {
    background: #4caf50;
    color: white;
    border: none;
    padding: 6px 10px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 11px;
    font-weight: 500;
    transition: background 0.2s;
    white-space: nowrap;
  }
  
  .answered-request-to-work-btn:hover {
    background: #45a049;
  }
  
  .answered-request-to-queue-btn {
    background: #ff9800;
    color: white;
    border: none;
    padding: 6px 10px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 11px;
    font-weight: 500;
    transition: background 0.2s;
    white-space: nowrap;
  }
  
  .answered-request-to-queue-btn:hover {
    background: #f57c00;
  }
  
  .answered-request-decline-btn {
    background: #f44336;
    color: white;
    border: none;
    padding: 6px 10px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 11px;
    font-weight: 500;
    transition: background 0.2s;
    white-space: nowrap;
  }
  
  .answered-request-decline-btn:hover {
    background: #d32f2f;
  }
  
  .answered-request-buttons {
    display: flex;
    gap: 6px;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-end;
  }
  
  /* Темна тема */
  .dark-theme .mentor-pending {
    color: #ffa726;
  }
  
  .dark-theme .mentor-waiting {
    color: #ffa726;
  }
  
  .dark-theme .status-active-section {
    background: rgba(76, 175, 80, 0.15);
  }
  
  .dark-theme .status-inactive-section {
    background: rgba(158, 158, 158, 0.1);
  }
  
  .dark-theme .status-timer {
    background: rgba(255, 255, 255, 0.1);
    color: #aaa;
  }
  
  .dark-theme .answered-request-current-status {
    border-top-color: #444;
    color: #777;
  }

  /* Модальне вікно підтвердження */
.confirm-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
  }
  
  .confirm-modal {
    background: white;
    border-radius: 12px;
    width: 400px;
    max-width: 90%;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
    animation: confirmFadeIn 0.2s ease;
  }
  
  @keyframes confirmFadeIn {
    from {
      opacity: 0;
      transform: scale(0.95);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
  
  .confirm-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 16px 20px;
    background: #fff3e0;
    border-bottom: 1px solid #e0e0e0;
    border-radius: 12px 12px 0 0;
  }
  
  .confirm-icon {
    font-size: 24px;
  }
  
  .confirm-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }
  
  .confirm-body {
    padding: 20px;
  }
  
  .confirm-body p {
    margin: 0 0 12px 0;
    color: #555;
    line-height: 1.5;
  }
  
  .confirm-task-name {
    background: #f5f5f5;
    padding: 8px 12px;
    border-radius: 8px;
    font-size: 13px;
    word-break: break-word;
  }
  
  .confirm-warning {
    color: #f44336 !important;
    font-size: 13px;
  }
  
  .confirm-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 16px 20px;
    border-top: 1px solid #e0e0e0;
  }
  
  .confirm-cancel-btn {
    background: #f5f5f5;
    border: 1px solid #ccc;
    padding: 8px 20px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    transition: background 0.2s;
  }
  
  .confirm-cancel-btn:hover {
    background: #e0e0e0;
  }
  
  .confirm-confirm-btn {
    background: #f44336;
    color: white;
    border: none;
    padding: 8px 20px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    transition: background 0.2s;
  }
  
  .confirm-confirm-btn:hover {
    background: #d32f2f;
  }
  
  /* Темна тема */
  .dark-theme .confirm-modal {
    background: #2a2a3a;
  }
  
  .dark-theme .confirm-header {
    background: #3e2a1e;
    border-bottom-color: #444;
  }
  
  .dark-theme .confirm-title {
    color: #e0e0e0;
  }
  
  .dark-theme .confirm-body p {
    color: #ccc;
  }
  
  .dark-theme .confirm-task-name {
    background: #1e1e2e;
    color: #e0e0e0;
  }
  
  .dark-theme .confirm-footer {
    border-top-color: #444;
  }
  
  .dark-theme .confirm-cancel-btn {
    background: #3a3a4a;
    border-color: #555;
    color: #e0e0e0;
  }
  
  .dark-theme .confirm-cancel-btn:hover {
    background: #4a4a5a;
  }`, "",{"version":3,"sources":["webpack://./src/components/covfile/HelpRequestsColumn.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,wCAAwC;IACxC,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,6DAA6D;IAC7D,YAAY;IACZ,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,2BAA2B;EAC7B;;EAEA;IACE,6DAA6D;EAC/D;;EAEA;IACE,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,2CAA2C;EAC7C;;EAEA;IACE,0BAA0B;IAC1B,wCAAwC;EAC1C;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,iBAAiB;IACjB,uCAAuC;EACzC;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,eAAe;EACjB;;EAEA,iBAAiB;EACjB;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,yCAAyC;EAC3C;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,uBAAuB;EACvB;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;;IAGE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;;IAGE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;EACA,6BAA6B;;AAE/B;IACI,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,kCAAkC;IAClC,8BAA8B;EAChC;;EAEA;IACE,qCAAqC;IACrC,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,yBAAyB;EAC3B;;EAEA,eAAe;EACf;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;IACpC,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA,iCAAiC;AACnC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,yCAAyC;IACzC,kCAAkC;EACpC;;EAEA;IACE;MACE,UAAU;MACV,sBAAsB;IACxB;IACA;MACE,UAAU;MACV,mBAAmB;IACrB;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA,eAAe;EACf;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB","sourcesContent":[".help-requests-column {\r\n    background: #fff;\r\n    border-radius: 12px;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n    margin-bottom: 20px;\r\n    overflow: hidden;\r\n  }\r\n  \r\n  .help-requests-header {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    padding: 15px 20px;\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n    color: white;\r\n    cursor: pointer;\r\n    user-select: none;\r\n    transition: background 0.3s;\r\n  }\r\n  \r\n  .help-requests-header:hover {\r\n    background: linear-gradient(135deg, #5a67d8 0%, #6b46a0 100%);\r\n  }\r\n  \r\n  .help-requests-icon {\r\n    font-size: 14px;\r\n    transition: transform 0.2s;\r\n  }\r\n  \r\n  .help-requests-title {\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .help-requests-content {\r\n    padding: 15px;\r\n  }\r\n  \r\n  .help-requests-section {\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .help-requests-subheader {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 10px 0;\r\n    margin-bottom: 10px;\r\n    border-bottom: 2px solid #e0e0e0;\r\n    font-weight: 600;\r\n    color: #333;\r\n  }\r\n  \r\n  .requests-count {\r\n    background: #667eea;\r\n    color: white;\r\n    padding: 2px 8px;\r\n    border-radius: 20px;\r\n    font-size: 12px;\r\n  }\r\n  \r\n  .help-requests-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 12px;\r\n  }\r\n  \r\n  .help-request-card {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 12px 15px;\r\n    background: #f8f9fa;\r\n    border-radius: 10px;\r\n    border-left: 4px solid #ff9800;\r\n    transition: transform 0.2s, box-shadow 0.2s;\r\n  }\r\n  \r\n  .help-request-card:hover {\r\n    transform: translateX(2px);\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .help-request-info {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 6px;\r\n  }\r\n  \r\n  .help-request-user {\r\n    font-weight: 600;\r\n    color: #333;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .help-request-task {\r\n    color: #555;\r\n    font-size: 13px;\r\n    word-break: break-word;\r\n  }\r\n  \r\n  .help-request-project {\r\n    color: #888;\r\n    font-size: 12px;\r\n  }\r\n  \r\n  .help-request-status {\r\n    display: inline-block;\r\n  }\r\n  \r\n  .status-badge {\r\n    display: inline-block;\r\n    padding: 2px 8px;\r\n    border-radius: 20px;\r\n    font-size: 11px;\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .status-in-queue {\r\n    background: #fff3e0;\r\n    color: #ff9800;\r\n  }\r\n  \r\n  .status-in-progress {\r\n    background: #e3f2fd;\r\n    color: #2196f3;\r\n  }\r\n  \r\n  .help-request-time {\r\n    font-family: monospace;\r\n    font-size: 13px;\r\n    color: #666;\r\n  }\r\n  \r\n  .help-request-take-btn {\r\n    background: #4caf50;\r\n    color: white;\r\n    border: none;\r\n    padding: 8px 16px;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    font-size: 13px;\r\n    font-weight: 500;\r\n    transition: background 0.2s;\r\n    white-space: nowrap;\r\n  }\r\n  \r\n  .help-request-take-btn:hover {\r\n    background: #45a049;\r\n  }\r\n  \r\n  .answered-requests-section {\r\n    margin-top: 10px;\r\n  }\r\n  \r\n  .answered-requests-header {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    padding: 10px 0;\r\n    cursor: pointer;\r\n    user-select: none;\r\n    font-weight: 600;\r\n    color: #555;\r\n    border-top: 1px solid #e0e0e0;\r\n    margin-top: 10px;\r\n  }\r\n  \r\n  .answered-requests-header:hover {\r\n    color: #333;\r\n  }\r\n  \r\n  .answered-requests-icon {\r\n    font-size: 12px;\r\n  }\r\n  \r\n  .answered-requests-title {\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .answered-requests-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    margin-top: 10px;\r\n  }\r\n  \r\n  .answered-request-card {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 10px 12px;\r\n    background: #e8f5e9;\r\n    border-radius: 8px;\r\n    border-left: 4px solid #4caf50;\r\n  }\r\n  \r\n  .answered-request-info {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 4px;\r\n  }\r\n  \r\n  .answered-request-user {\r\n    font-weight: 600;\r\n    color: #333;\r\n    font-size: 13px;\r\n  }\r\n  \r\n  .answered-request-task {\r\n    color: #555;\r\n    font-size: 12px;\r\n  }\r\n  \r\n  .answered-request-mentor {\r\n    color: #666;\r\n    font-size: 11px;\r\n  }\r\n  \r\n  .answered-request-answer {\r\n    font-size: 11px;\r\n    color: #4caf50;\r\n    font-weight: 500;\r\n  }\r\n  \r\n  .answered-request-timer {\r\n    font-size: 11px;\r\n    font-family: monospace;\r\n    color: #ff9800;\r\n  }\r\n  \r\n  .answered-request-timer.expired {\r\n    color: #f44336;\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .answered-request-status {\r\n    font-size: 11px;\r\n    color: #4caf50;\r\n    font-weight: 500;\r\n  }\r\n  \r\n  .answered-request-buttons {\r\n    display: flex;\r\n    gap: 8px;\r\n    align-items: center;\r\n  }\r\n  \r\n  .answered-request-done-btn {\r\n    background: #2196f3;\r\n    color: white;\r\n    border: none;\r\n    padding: 6px 12px;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    font-size: 11px;\r\n    font-weight: 500;\r\n    transition: background 0.2s;\r\n  }\r\n  \r\n  .answered-request-done-btn:hover {\r\n    background: #1976d2;\r\n  }\r\n  \r\n  .answered-request-link {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 28px;\r\n    height: 28px;\r\n    background: #e0e0e0;\r\n    border-radius: 6px;\r\n    text-decoration: none;\r\n    color: #666;\r\n    font-weight: bold;\r\n    transition: background 0.2s, color 0.2s;\r\n  }\r\n  \r\n  .answered-request-link:hover {\r\n    background: #ccc;\r\n    color: #333;\r\n  }\r\n  \r\n  .no-requests-message {\r\n    text-align: center;\r\n    padding: 30px;\r\n    color: #999;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  /* Modal Styles */\r\n  .modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .modal-content {\r\n    background: white;\r\n    border-radius: 12px;\r\n    width: 90%;\r\n    max-width: 500px;\r\n    max-height: 80vh;\r\n    overflow: auto;\r\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\r\n  }\r\n  \r\n  .modal-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 15px 20px;\r\n    border-bottom: 1px solid #e0e0e0;\r\n  }\r\n  \r\n  .modal-header h3 {\r\n    margin: 0;\r\n    color: #333;\r\n  }\r\n  \r\n  .modal-close {\r\n    background: none;\r\n    border: none;\r\n    font-size: 24px;\r\n    cursor: pointer;\r\n    color: #999;\r\n  }\r\n  \r\n  .modal-close:hover {\r\n    color: #333;\r\n  }\r\n  \r\n  .modal-body {\r\n    padding: 20px;\r\n  }\r\n  \r\n  .modal-task-info {\r\n    background: #f5f5f5;\r\n    padding: 12px;\r\n    border-radius: 8px;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .modal-task-info div {\r\n    margin-bottom: 5px;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .modal-options {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n  }\r\n  \r\n  .modal-option {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .minutes-input {\r\n    width: 70px;\r\n    padding: 5px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    margin-left: 5px;\r\n  }\r\n  \r\n  .modal-footer {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 10px;\r\n    padding: 15px 20px;\r\n    border-top: 1px solid #e0e0e0;\r\n  }\r\n  \r\n  .modal-cancel {\r\n    background: #f5f5f5;\r\n    border: 1px solid #ccc;\r\n    padding: 8px 16px;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .modal-submit {\r\n    background: #4caf50;\r\n    color: white;\r\n    border: none;\r\n    padding: 8px 20px;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .modal-submit:hover {\r\n    background: #45a049;\r\n  }\r\n  \r\n  /* Dark theme support */\r\n  .dark-theme .help-requests-column {\r\n    background: #1e1e2e;\r\n  }\r\n  \r\n  .dark-theme .help-requests-subheader {\r\n    color: #e0e0e0;\r\n    border-bottom-color: #444;\r\n  }\r\n  \r\n  .dark-theme .help-request-card {\r\n    background: #2a2a3a;\r\n  }\r\n  \r\n  .dark-theme .help-request-user,\r\n  .dark-theme .help-request-task,\r\n  .dark-theme .help-request-project {\r\n    color: #e0e0e0;\r\n  }\r\n  \r\n  .dark-theme .answered-request-card {\r\n    background: #1e3a2e;\r\n  }\r\n  \r\n  .dark-theme .answered-request-user,\r\n  .dark-theme .answered-request-task,\r\n  .dark-theme .answered-request-mentor {\r\n    color: #e0e0e0;\r\n  }\r\n  \r\n  .dark-theme .modal-content {\r\n    background: #2a2a3a;\r\n    color: #e0e0e0;\r\n  }\r\n  \r\n  .dark-theme .modal-task-info {\r\n    background: #1e1e2e;\r\n  }\r\n  \r\n  .dark-theme .modal-header h3 {\r\n    color: #e0e0e0;\r\n  }\r\n  /* Додайте до існуючого CSS */\r\n\r\n.mentor-confirmed {\r\n    color: #4caf50;\r\n  }\r\n  \r\n  .mentor-pending {\r\n    color: #ff9800;\r\n  }\r\n  \r\n  .mentor-waiting {\r\n    font-size: 10px;\r\n    color: #ff9800;\r\n    font-style: italic;\r\n  }\r\n  \r\n  .status-section {\r\n    margin-top: 6px;\r\n    padding: 4px 8px;\r\n    border-radius: 6px;\r\n    transition: all 0.3s ease;\r\n  }\r\n  \r\n  .status-active-section {\r\n    background: rgba(76, 175, 80, 0.1);\r\n    border-left: 3px solid #4caf50;\r\n  }\r\n  \r\n  .status-inactive-section {\r\n    background: rgba(158, 158, 158, 0.05);\r\n    border-left: 3px solid #9e9e9e;\r\n    opacity: 0.7;\r\n  }\r\n  \r\n  .status-header {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n  }\r\n  \r\n  .status-icon {\r\n    font-size: 12px;\r\n  }\r\n  \r\n  .status-name {\r\n    font-size: 11px;\r\n    font-weight: 500;\r\n  }\r\n  \r\n  .status-active-section .status-name {\r\n    color: #4caf50;\r\n  }\r\n  \r\n  .status-inactive-section .status-name {\r\n    color: #9e9e9e;\r\n  }\r\n  \r\n  .status-timer {\r\n    font-family: monospace;\r\n    font-size: 11px;\r\n    color: #666;\r\n    background: rgba(0, 0, 0, 0.05);\r\n    padding: 2px 6px;\r\n    border-radius: 12px;\r\n    margin-left: auto;\r\n  }\r\n  \r\n  .answered-request-current-status {\r\n    font-size: 10px;\r\n    color: #888;\r\n    margin-top: 6px;\r\n    font-family: monospace;\r\n    padding-top: 4px;\r\n    border-top: 1px dashed #e0e0e0;\r\n  }\r\n  \r\n  .answered-request-to-work-btn {\r\n    background: #4caf50;\r\n    color: white;\r\n    border: none;\r\n    padding: 6px 10px;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    font-size: 11px;\r\n    font-weight: 500;\r\n    transition: background 0.2s;\r\n    white-space: nowrap;\r\n  }\r\n  \r\n  .answered-request-to-work-btn:hover {\r\n    background: #45a049;\r\n  }\r\n  \r\n  .answered-request-to-queue-btn {\r\n    background: #ff9800;\r\n    color: white;\r\n    border: none;\r\n    padding: 6px 10px;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    font-size: 11px;\r\n    font-weight: 500;\r\n    transition: background 0.2s;\r\n    white-space: nowrap;\r\n  }\r\n  \r\n  .answered-request-to-queue-btn:hover {\r\n    background: #f57c00;\r\n  }\r\n  \r\n  .answered-request-decline-btn {\r\n    background: #f44336;\r\n    color: white;\r\n    border: none;\r\n    padding: 6px 10px;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    font-size: 11px;\r\n    font-weight: 500;\r\n    transition: background 0.2s;\r\n    white-space: nowrap;\r\n  }\r\n  \r\n  .answered-request-decline-btn:hover {\r\n    background: #d32f2f;\r\n  }\r\n  \r\n  .answered-request-buttons {\r\n    display: flex;\r\n    gap: 6px;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n    justify-content: flex-end;\r\n  }\r\n  \r\n  /* Темна тема */\r\n  .dark-theme .mentor-pending {\r\n    color: #ffa726;\r\n  }\r\n  \r\n  .dark-theme .mentor-waiting {\r\n    color: #ffa726;\r\n  }\r\n  \r\n  .dark-theme .status-active-section {\r\n    background: rgba(76, 175, 80, 0.15);\r\n  }\r\n  \r\n  .dark-theme .status-inactive-section {\r\n    background: rgba(158, 158, 158, 0.1);\r\n  }\r\n  \r\n  .dark-theme .status-timer {\r\n    background: rgba(255, 255, 255, 0.1);\r\n    color: #aaa;\r\n  }\r\n  \r\n  .dark-theme .answered-request-current-status {\r\n    border-top-color: #444;\r\n    color: #777;\r\n  }\r\n\r\n  /* Модальне вікно підтвердження */\r\n.confirm-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 2000;\r\n  }\r\n  \r\n  .confirm-modal {\r\n    background: white;\r\n    border-radius: 12px;\r\n    width: 400px;\r\n    max-width: 90%;\r\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\r\n    animation: confirmFadeIn 0.2s ease;\r\n  }\r\n  \r\n  @keyframes confirmFadeIn {\r\n    from {\r\n      opacity: 0;\r\n      transform: scale(0.95);\r\n    }\r\n    to {\r\n      opacity: 1;\r\n      transform: scale(1);\r\n    }\r\n  }\r\n  \r\n  .confirm-header {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    padding: 16px 20px;\r\n    background: #fff3e0;\r\n    border-bottom: 1px solid #e0e0e0;\r\n    border-radius: 12px 12px 0 0;\r\n  }\r\n  \r\n  .confirm-icon {\r\n    font-size: 24px;\r\n  }\r\n  \r\n  .confirm-title {\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    color: #333;\r\n  }\r\n  \r\n  .confirm-body {\r\n    padding: 20px;\r\n  }\r\n  \r\n  .confirm-body p {\r\n    margin: 0 0 12px 0;\r\n    color: #555;\r\n    line-height: 1.5;\r\n  }\r\n  \r\n  .confirm-task-name {\r\n    background: #f5f5f5;\r\n    padding: 8px 12px;\r\n    border-radius: 8px;\r\n    font-size: 13px;\r\n    word-break: break-word;\r\n  }\r\n  \r\n  .confirm-warning {\r\n    color: #f44336 !important;\r\n    font-size: 13px;\r\n  }\r\n  \r\n  .confirm-footer {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 12px;\r\n    padding: 16px 20px;\r\n    border-top: 1px solid #e0e0e0;\r\n  }\r\n  \r\n  .confirm-cancel-btn {\r\n    background: #f5f5f5;\r\n    border: 1px solid #ccc;\r\n    padding: 8px 20px;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    transition: background 0.2s;\r\n  }\r\n  \r\n  .confirm-cancel-btn:hover {\r\n    background: #e0e0e0;\r\n  }\r\n  \r\n  .confirm-confirm-btn {\r\n    background: #f44336;\r\n    color: white;\r\n    border: none;\r\n    padding: 8px 20px;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    transition: background 0.2s;\r\n  }\r\n  \r\n  .confirm-confirm-btn:hover {\r\n    background: #d32f2f;\r\n  }\r\n  \r\n  /* Темна тема */\r\n  .dark-theme .confirm-modal {\r\n    background: #2a2a3a;\r\n  }\r\n  \r\n  .dark-theme .confirm-header {\r\n    background: #3e2a1e;\r\n    border-bottom-color: #444;\r\n  }\r\n  \r\n  .dark-theme .confirm-title {\r\n    color: #e0e0e0;\r\n  }\r\n  \r\n  .dark-theme .confirm-body p {\r\n    color: #ccc;\r\n  }\r\n  \r\n  .dark-theme .confirm-task-name {\r\n    background: #1e1e2e;\r\n    color: #e0e0e0;\r\n  }\r\n  \r\n  .dark-theme .confirm-footer {\r\n    border-top-color: #444;\r\n  }\r\n  \r\n  .dark-theme .confirm-cancel-btn {\r\n    background: #3a3a4a;\r\n    border-color: #555;\r\n    color: #e0e0e0;\r\n  }\r\n  \r\n  .dark-theme .confirm-cancel-btn:hover {\r\n    background: #4a4a5a;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
